export interface Template {
  id: string;
  name: string;
  description: string;
}

export const TEMPLATES: Template[] = [
  { id: 'default', name: 'Default', description: 'Clean, readable prose' },
  { id: 'blog', name: 'Blog', description: 'Wide reading column with drop-cap' },
  { id: 'rfc', name: 'RFC', description: 'Technical doc / design doc' },
  { id: 'resume', name: 'Resume', description: 'Print-ready single-page' },
  { id: 'recipe', name: 'Recipe', description: 'Friendly recipe card' },
];

export function isTemplateId(id: string): boolean {
  return TEMPLATES.some((t) => t.id === id);
}
